<template>
  <div>
    <el-collapse v-model="activeNames">
      <el-collapse-item
        class="dataContent"
        @mousedown.native="collapseMouseDown($event, '1')"
        title="数据源"
        name="1"
      >
        <div class="dataSource-item" @click="goToChooseData">
          <span>进入数据管理后台 </span>
        </div>
      </el-collapse-item>
      <el-collapse-item
        class="dataContent"
        @mousedown.native="collapseMouseDown($event, '2')"
        title="更多"
        name="2"
      >
        <auto-update-timer :isLocal="false"/>
        <div class="content-item mt16 verticallyCenter clearFloat">
          <div class="font14 mr16 no-break">链接跳转至</div>
          <el-radio-group v-model="openBlankPage">
            <el-radio label="新页面">新页面</el-radio>
            <el-radio label="当前页面">当前页面</el-radio>
          </el-radio-group>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import { repairApp } from "utils/saveModule"
import autoUpdateTimer from "components/toolbar-option-components/utilsComponents/autoUpdateTimer/autoUpdateTimer.vue"
export default {
  components: {
    autoUpdateTimer
  },
  data() {
    return {
      this1: this,
      labelTrue: true,
      labelFalse: false,
      activeNames: ["1"],
      collapseActiveNames: [],
      activeIndex: 0,
      fetchEnd: false
    }
  },
  props: {
    options: {
      type: Object
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    selectOptionsData: {
      get() {
        return this.options.selectOptions || []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "selectOptions", false)
      }
    },
    formateSelectData() {
      const res = []
      this.selectOptionsData
        .filter(item => item)
        .forEach(item => {
          res.push([
            ["名称", item.label],
            ["链接", item.value]
          ])
        })
      return res
    },
    restDataUrl: {
      get() {
        return this.options && this.options.restDataUrl ? this.options.restDataUrl : null
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "restDataUrl", false)
      }
    },
    openBlankPage: {
      get() {
        return this.options.openBlankPage ? "新页面" : "当前页面"
      },
      set(newVal) {
        let temp = true
        if (newVal == "新页面") {
          temp = true
        } else {
          temp = false
        }
        this.$changeOptionsEV(temp, "openBlankPage", false)
      }
    }
  },
  methods: {
    collapseMouseDown($event, val) {
      if ($event.target.classList[0] === "el-collapse-item__header") {
        const _index = this.collapseActiveNames.findIndex(it => it === val)
        _index === -1 ? this.collapseActiveNames.push(val) : ""
      }
    },
    goToChooseData() {
      if (this.fetchEnd) return
      this.fetchEnd = true
      const { websiteId, pageId, sign, wfwfid, homePageId, pageType } = this.$store.state.states.getDataPageIds
      let target = this.getAttrById.call(this, this.$store.state[this.request_prefix], this.ids)
      let options = target.options ? target.options : target
      let { moduleId, appId } = options

      if (!!!moduleId || !!!appId) {
        // "31CB73E03E24BBFF" 对应 31CB73E03E24BBFF
        this.$saveModule(this.ids, "31CB73E03E24BBFF", "临时", false)
          .then(res => {
            this.fetchEnd = false
            if (!!res.appId) {
              window.open(`/engine2/data/api-v2/admin/general/${res.appId}?w=${websiteId}&p=${pageId}&init=1`)
            }
          })
          .catch(err => (this.fetchEnd = false))
      }
      this.fetchEnd = false
      if (!!appId) window.open(`/engine2/data/api-v2/admin/general/${appId}?w=${websiteId}&p=${pageId}`)
      // 数据自动渲染
      window.addEventListener("storage", this.listenStorage)
    },
    async getBaseModuleDataLoop() {
      if (!!!this.checkStatus()) {
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          type: "error",
          message: "请进入数据管理后台添加数据"
        })
        return
      }
      const { pageId, wfwfid, websiteId } = this.$store.state.states.getDataPageIds
      const appId = this.options.appId
      this.restDataUrl = `engine2/data/api-v2/${appId}/rest-classify?wfwfid=${wfwfid}&w=${websiteId}&p=${pageId}`
      let res = await this.getGeneralRest(appId, wfwfid, websiteId, pageId)
      // 将接口返回来的状态写入options中
      if (res.data?.data?.engineInstance) {
        const engineInstance = res.data.data.engineInstance
        this.$changeOptionsEV(engineInstance.checkIp, "checkIp", false, false, false, true)
        this.$changeOptionsEV(engineInstance.openSensitiveWords, "openSensitiveWords", false, false, false, true)
      }
      let datas,
        targetData = []

      this.setMyFetchParam(appId) // 设置请求参数
      // 脏数据处理
      if (res.data.message === "mh_engine_40009") {
        this.handleRepairApp(appId)
      }
      const engineInstance = res.data.data.engineInstance
      if (res.data.code === 1) {
        // 如果当前组件中不存在detailPageId，需要创建子页面
        // if (!this.options.hasOwnProperty("detailPageId") && this.request_prefix !== "bigScreen") {
        // 节流创建子页面,避免重复创建
        // createNavMenuSubPageHandle.call(this, appId)
        // }
        const engineInstanceId = engineInstance.publicId
        this.$changeOptionsEV(
          engineInstanceId,
          "engineInstanceId",
          false,
          null,
          {
            rect_id: this.ids.rect_id,
            container_id: this.ids.container_id
          },
          true
        )
        datas = res.data.data.generalDataTypes
        this.engineInstanceRealId = engineInstance.publicId
        this.doObj(datas, targetData)
        this.$changeOptionsEV(targetData, "selectOptions", false, false, false, true)
        if (engineInstance) {
          this.$changeOptionsEV(engineInstance.id, "engineInstanceId_10", false, false, false, true)
        }
      }
    },
    handleRepairApp(appId) {
      // 根据当前appid，获取到对应的组件
      const _ids = this.ids
      const options = this.options
      // 需要判断当前组件类型，如果是基于自由布局开发的搜索组件/导航菜单，需要特殊处理
      const isSearchComponent = options.pluginName?.includes("searchComponentPlugin")
      const isNavComponent = options.innerElement.toLowerCase().includes("nav")
      repairApp.call(this, "31CB73E03E24BBFF", "临时", appId, false, isSearchComponent, isNavComponent).then(res => {
        // 替换原来的appId
        console.log("// 替换原来的appId", _ids)
        if (!!res.appId) {
          this.$changeOptionsEV(res.appId, "appId", null, false, _ids, true)
        }
      })
    },
    doObj(datas, targetData) {
      for (let key in datas) {
        targetData.push({
          label: datas[key].name,
          value: datas[key].url,
          iconUrl: datas[key].iconUrl,
          publicId: datas[key].publicId,
          openTarget: datas[key].openTarget, // 1 当前窗口 2 新窗口
          openType: datas[key].openType, // 1 自定义页面 2 链接地址
          showType: datas[key].showType, // openType === 1 时  【0: 默认，1：列表、2：简介、3：简介+列表 4：简介+分类列】
          children: []
        })
        if (typeof datas[key].subGeneralDataTypes == "object") {
          this.doObj(datas[key].subGeneralDataTypes, targetData[key].children)
        }
      }
    },
    setMyFetchParam(appId) {
      const { pageId, wfwfid, websiteId } = this.$store.state.states.getDataPageIds
      this.$changeOptionsEV(
        {
          pageId: pageId,
          wfwfid,
          websiteId,
          appId
        },
        "myFetchParam",
        false,
        null,
        {
          rect_id: this.ids.rect_id,
          container_id: this.ids.container_id
        },
        true
      )
    },
    checkStatus() {
      return this.getAttrById.call(this, this.$store.state[this.request_prefix], this.ids)
    },
    async getGeneralRest(appId, wfwfid, websiteId, pageId) {
      return this.$API.queryAppCategoryAndApp({
        appId: appId,
        wfwfid: wfwfid,
        websiteId: websiteId,
        pageId: pageId
      })
    },
    listenStorage(e) {
      if (e.key == "page-v2-general-data-type-add") {
        console.log("后台分类数据更新 :>>")
        this.getBaseModuleDataLoop()
      }
    }
  },
  mounted() {
    if (this.options.appId) {
      this.getBaseModuleDataLoop()
    }
  },
  beforeDestroy() {
    window.removeEventListener("storage", this.listenStorage)
  }
}
</script>

<style lang="scss" scoped>
.data-source-type {
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}
.data-source-type::v-deep .el-radio {
  margin-bottom: 16px;
}
.data-source-type::v-deep .el-radio__inner {
  background-color: rgba(255, 255, 255, 0);
}
.dataContent {
  font-size: 14px;
  line-height: 22px;
  color: rgba(255, 255, 255, 0.8);
}
.getDataBtn {
  background: var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #ffffff;
  padding: 6px 0px;
}
.getDataBtn:hover {
  cursor: pointer;
}
.dataSource-item {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  background: var(--leftMenuBgColor);
  border: 1px solid var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  color: var(--themeColor);
  &:hover {
    cursor: pointer;
  }
}
.dataUrl-item input {
  width: 252px;
  height: 32px;
  background: #35383f;
  color: rgba(255, 255, 255, 0.2);
}
.dataUrl-item .tips {
  color: var(--fourthTextColor);
}
</style>
